import { render, staticRenderFns } from "./QrRegistration.vue?vue&type=template&id=78a538d0"
import script from "./QrRegistration.vue?vue&type=script&lang=ts"
export * from "./QrRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports